import React, { useState, useMemo } from "react";

import { Loader } from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { CareerIcon } from "@components/career-icon";
import { CareersSelectedLeaderboardModal } from "@components/modals/careers-selected-leaderboard/careers-selected-leaderboard.modal";
import { useCareerImageUrls } from "@src/hooks/queries";

import "./top-careers-selected.scss";

const MaxCareersDisplay = 3;

export const TopCareersSelected = ({
  topCareers,
  isLoading,
  activeUsers,
  users,
  limit = MaxCareersDisplay,
  breadcrumbLabel,
}) => {
  const [openModal, setOpenModal] = useState();
  const [careerSelected, setCareerSelected] = useState();

  const careersToFetch = useMemo(
    () => topCareers?.slice(0, limit) || [],
    [topCareers, limit]
  );

  const careerIconUrls = useCareerImageUrls(
    careersToFetch,
    (career) => career.id,
    (career) => ({ transfrId: career.transfrId })
  );

  const openLeaderboardModal = (career) => {
    setCareerSelected(career);
    setOpenModal(true);
  };

  if (isLoading) {
    return <Loader></Loader>;
  }

  return (
    topCareers?.length > 0 && (
      <>
        <div className="trek-insights-header">
          <h2>Top Careers Selected</h2>
        </div>
        <div className="top-careers-selected-container">
          {topCareers?.slice(0, limit).map((career, index) => (
            <CareerIcon
              key={`${career.code}-${index}`}
              name={career.title}
              badge={career.totalSelected}
              onClick={() => openLeaderboardModal(career)}
              iconUrl={careerIconUrls.get(career.id)}
            />
          ))}
          {topCareers?.length > limit && (
            <div className="view-all-button">
              <Button
                onClick={() => openLeaderboardModal()}
                title={"View all high rated careers"}
              >
                +{topCareers.length - limit}
              </Button>
              <h3>View All</h3>
            </div>
          )}
        </div>
        {topCareers && (
          <CareersSelectedLeaderboardModal
            open={openModal}
            onCancel={() => setOpenModal()}
            career={careerSelected}
            topCareers={topCareers}
            activeUsers={activeUsers}
            breadcrumbLabel={breadcrumbLabel}
            users={users}
          />
        )}
      </>
    )
  );
};
